import { useRef, useMemo } from 'react';
import { useUploadFiles } from './useUploadFiles';
export const useFileUploadHandler = (config) => {
    const uploadFiles = useUploadFiles();
    const customRef = useRef(null);
    const { onBeforeUpload, onUploadStart, onChange, ref: userRef } = config !== null && config !== void 0 ? config : {};
    const fileInputRef = userRef !== null && userRef !== void 0 ? userRef : customRef;
    return useMemo(() => ({
        handleChange(event) {
            var _a;
            const selectedFiles = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.files;
            if (selectedFiles) {
                uploadFiles({ files: selectedFiles, onUploadStart, onBeforeUpload });
                // No change will occur if the same file is selected again w/o clearing the value
                if (typeof fileInputRef !== 'function' && fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
            }
            onChange === null || onChange === void 0 ? void 0 : onChange(event);
        },
        fileInputRef,
    }), [onBeforeUpload, onUploadStart, uploadFiles, onChange, fileInputRef]);
};
//# sourceMappingURL=useFileUploadHandler.js.map